import { normalizeCrossChartOptionValue } from "shared";

const CROSS_OPTION_CHART_TYPES = new Set(["cross-option", "option"]);

const isBooleanLikeSpeechValue = (value: string): boolean => {
  const lower = value.toLowerCase();
  return (
    lower === "true" ||
    lower === "false" ||
    lower === "positive" ||
    lower === "negative"
  );
};

function normalizeSpeechCrossOptionFieldValue(
  value: string,
  fieldType: string | undefined
): string {
  const isCrossOptionField =
    fieldType !== undefined && CROSS_OPTION_CHART_TYPES.has(fieldType);

  if (!isCrossOptionField && !isBooleanLikeSpeechValue(value)) {
    return value;
  }

  const normalized = normalizeCrossChartOptionValue(value);
  return normalized ?? value;
}

export { normalizeSpeechCrossOptionFieldValue };
